// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".signature-step label {\n  color: #222222;\n  font-size: 15px;\n  line-height: 1.5;\n  margin-bottom: 4px;\n}\n.signature-step .el-upload-dragger {\n  height: 100px;\n  line-height: 100px;\n}\n.signature-step .el-upload-dragger .el-icon-upload {\n  margin-top: 20px;\n}", ""]);
// Exports
module.exports = exports;
